import { resolveCategoryRedirect } from '~/helpers/categoryRedirect'
import { useCategoryStore } from '~/stores/category'

/**
 * 301 from the old (Algolia) category paths to the Typesense category paths.
 * Runs for SSR (real 301 for crawlers and external links) and for in-app navigation (old links in CMS content).
 */
export default defineNuxtRouteMiddleware((to) => {
  // A live category always wins: a rule must not hide a category that exists (again) in the category tree,
  // e.g. lumilingot, which was moved in the migration and later re-created in Struct
  const categoryPath = to.path.replace(/^\/[a-z]{2}(?=\/category\/)/, '').replace(/^\/+|\/+$/g, '')
  if (useCategoryStore().getCategoryByPath(categoryPath)) return

  const target = resolveCategoryRedirect(to.path)
  if (target) {
    return navigateTo({ path: target, query: to.query, hash: to.hash }, { redirectCode: 301 })
  }
})
